import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import VehiclesFilterModal from './containers/VehiclesFilterModal';
import { ReactComponent as IconFilter } from '../../../../assets/img/icn-filter.svg';
import { ReactComponent as IconSearch } from '../../../../assets/img/icn-search.svg';
import { useVehicleFilterContext } from '../../Vehicles';
import { actions as vehiclesActions } from '../../../../redux/vehicles';
import { trackEvent, EVENT_TYPES } from '../../../../api/analytics';

const VehiclesFilter = ({ onExportError }) => {
  const [vehiclesFilter, setVehiclesFilter] = useVehicleFilterContext();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const dispatch = useDispatch();

  const searchPhraseFormik = useFormik({
    initialValues: {
      searchPhrase: '',
    },
    onSubmit: ({ searchPhrase }) => handleSearchPhraseSubmit(searchPhrase),
    validateOnChange: false,
  });

  useEffect(() => {
    searchPhraseFormik.setFieldValue('searchPhrase', vehiclesFilter.searchPhrase || '');
    onExportError(null);
    // eslint-disable-next-line
  }, [vehiclesFilter]);

  const handleSearchPhraseSubmit = (searchPhrase) => {
    const newVehiclesFilter = {
      ...vehiclesFilter,
    };

    if (!searchPhrase) {
      delete newVehiclesFilter.searchPhrase;
    } else {
      newVehiclesFilter.searchPhrase = searchPhrase;
    }

    if (vehiclesFilter.searchPhrase === newVehiclesFilter.searchPhrase) {
      dispatch(vehiclesActions.setPagedResultLoaded(false));
    } else {
      setVehiclesFilter({
        ...newVehiclesFilter,
      });

      // Track event in Analytics
      trackEvent(EVENT_TYPES.VEHICLES_FILTER_SEARCHED);
    }
  };

  return (
    <div className="d-flex">
      <form onSubmit={searchPhraseFormik.handleSubmit}>
        <div className="form-group-inline mr-2">
          <div className="input-group">
            <input
              id="searchPhrase"
              name="searchPhrase"
              type="text"
              className="form-control"
              placeholder="Search vehicles"
              value={searchPhraseFormik.values.searchPhrase}
              onChange={searchPhraseFormik.handleChange}
              style={{ borderRadius: '0.1875rem', width: '12rem' }}
            />
            <button type="submit" className="btn btn-link is-field-button">
              <IconSearch />
            </button>
          </div>
        </div>
      </form>
      <button
        type="button"
        className="btn button mr-2 filter-btn"
        data-variation="light-blue"
        data-testid="vehicleFilterBtn"
        style={{ maxWidth: '5rem' }}
        onClick={() => setShowFilterModal(true)}
      >
        <span className="d-flex align-items-center">
          <IconFilter />
          {' '}
          Filter
        </span>
      </button>
      {showFilterModal && (
        <VehiclesFilterModal searchPhrase={searchPhraseFormik.values.searchPhrase} setShowModal={setShowFilterModal} />
      )}
    </div>
  );
};

VehiclesFilter.propTypes = {
  onExportError: PropTypes.func.isRequired,
};

export default VehiclesFilter;
